import { dataModels } from '../../dataModels'
import { actionTypes } from './actions'
import { util } from '../../util'
const today = new Date()
const yesterday = new Date()
yesterday.setDate(yesterday.getDate() - 1)

const initialState = {
    order_filters: dataModels.getOrderFilters(),
    order_loading: false,
    orders_list: [],
    count: 0,
    pageNo: 1,
    size: 10,
    order: 'desc',
    orderBy: 'order_id',
    order_error: '',
    fetch_order_failed: false,
    order_status: 'canceled',
}

export const ordersReducer = (state = initialState, action) => {
    const { type, payload } = action
    const { shallowHelper } = util
    switch (type) {
        case actionTypes.INITIAL_ORDER_FILTERS: {
            return shallowHelper(state, {
                order_filters: payload,
                initial_order_filters: payload,
            })
        }

        case actionTypes.CLEAR_ORDER_FILTERS: {
            return shallowHelper(state, {
                order_filters: dataModels.getOrderFilters(),
            })
        }

        case actionTypes.UPDATE_ORDER_FILTERS: {
            return shallowHelper(state, {
                order_filters: payload,
            })
        }

        case actionTypes.ORDER_LOADING_START: {
            return shallowHelper(state, { order_loading: true })
        }

        case actionTypes.ORDER_LOADING_END: {
            return shallowHelper(state, { order_loading: false })
        }

        case actionTypes.SAGA_FETCH_ORDERS_SUCCESS: {
            return shallowHelper(state, {
                ...payload,
                order_error: '',
                order_loading: false,
            })
        }

        case actionTypes.ORDER_ERROR: {
            return shallowHelper(state, {
                order_error: payload,
            })
        }

        case actionTypes.DISPATCH_CLEAR_ORDER_FILTERS: {
            const filters = state.order_filters.map(filter => ({
                ...filter,
                display_value: filter.type !== 'string' ? [] : '',
                post_value: filter.type !== 'string' ? [] : '',
                start_value: yesterday.toISOString(),
                end_value: today.toISOString(),
            }))

            return shallowHelper(state, { order_filters: filters })
        }

        default: {
            return state
        }
    }
}
